/* istanbul ignore file */
import React, { MouseEventHandler, useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { v4 as uuidV4 } from 'uuid';
import { isEmpty, isNil } from 'lodash';
import SahamDrawer from 'components/SahamDrawer';
import { translate } from 'containers/services/translate';
import {
  EMPTY_ASSIGN_EXPERT_TRANSACTION,
  OPPOSING_LAWYER_FIELDS,
} from 'containers/data-structure';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { ContainerInDrawer } from 'containers/LawyerFeeNote/styled-components';
import { get, uniqueId } from 'lodash';
import SahamDialog from 'components/SahamDialog';
import {
  returnDefaultCodeByType,
  returnReserveCodeByType,
} from 'containers/CourtManagerLegalProceedings/AssignExpert/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import MissionForm from 'containers/TransactionManagerTimeLine/ContactVictim/MissionForm';
import { resolveExpertiseType } from 'containers/CourtManagerLegalProceedings/utils';
import { constructOldAssignement } from 'containers/CourtManagerAssignedExpertise/utils';
import {
  SECOND_EXAMINATION_OPPOSING_LAWYER,
  SECOND_EXAMINATION_VICTIM,
} from 'containers/TransactionManagerTimeLine/ContactVictim/constants';
import { isNilOrEmptyValue } from 'containers/TransactionManagerTimeLine/ContactVictim/utils';
import { TransactionType } from 'typings/globalTypes';

export interface MissionDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  listings: any;
  requestAssignedExpert: Function;
  claimId: number;
  claimNumber: string;
  corporealExperts: any;
  requestGetExpertUsers: Function;
  riskKey: string;
  victimId: number | null;
  transactionId: number;
  requestGetMissionTransaction: Function;
  missionToUpdate: any;
  requestUpdateMissionTransaction?: Function;
  transactionInfo: TransactionType;
}

const MissionDrawer: React.FC<MissionDrawerProps> = (props): JSX.Element => {
  const [assignExpert, setAssignExpert] = React.useState(
    props.missionToUpdate
      ? { ...props.missionToUpdate }
      : {
          ...EMPTY_ASSIGN_EXPERT_TRANSACTION,
          victims: [props.victimId],
        },
  );
  const [generateLetter, setGenerateLetter] = React.useState<boolean>(
    !isEmpty(props.missionToUpdate)
      ? get(props.missionToUpdate, 'generateAssignementLetter', false)
      : false,
  );
  const [secondExaminationType, setSecondExaminationType] = React.useState<
    string
  >(
    props.missionToUpdate
      ? get(props.missionToUpdate, 'secondExamination.type')
      : '',
  );

  const [opposingLawyerInfo, setOpposingLawyerInfo] = React.useState<{}>(
    props.missionToUpdate
      ? get(props.missionToUpdate, 'secondExamination.opposingLawyer', {})
      : {},
  );
  useEffect(() => {
    if (!isEmpty(props.missionToUpdate)) {
      props.requestGetExpertUsers(
        resolveExpertiseType(Number(get(props.missionToUpdate, 'type'))),
      );
    }
  }, []);

  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);
  const handleValidation = () => {
    if (
      props.requestUpdateMissionTransaction &&
      !isEmpty(props.missionToUpdate)
    ) {
      const assignement = constructOldAssignement(
        get(props.missionToUpdate, 'assignedExperts'),
        get(assignExpert, 'assignedExperts'),
        get(props.missionToUpdate, 'id'),
      );
      props.requestUpdateMissionTransaction(
        {
          ...assignExpert,
          document: {},
          victims: get(assignExpert, 'victims', []).map((el: any) => el.id),
          vehicles: [],
          secondExamination:
            secondExaminationType === SECOND_EXAMINATION_VICTIM
              ? {
                  victimId: props.victimId,
                  id: get(props.missionToUpdate, 'secondExamination.id', {}),
                  opposingLawyerId: null,
                  opposingLawyer: {},
                }
              : {
                  opposingLawyer: {
                    ...opposingLawyerInfo,
                  },
                  id: get(props.missionToUpdate, 'secondExamination.id', {}),
                },
          transactionId: props.transactionId,
          assignement: assignement,
          intervenantSagis: !isEmpty(
            assignement.filter((el: any) => !el.isForDelete && !el.id),
          )
            ? assignement
                .filter((el: any) => !el.isForDelete && !el.id)
                .map((element: any) => ({
                  intervenantTypeCode: returnDefaultCodeByType(
                    Number(get(assignExpert, 'type')),
                  ),
                  intervenantCode: element.expertCode,
                }))
            : [],
          excludedIntervenant: !isEmpty(
            assignement.filter((el: any) => el.isForDelete),
          )
            ? assignement
                .filter((el: any) => el.isForDelete)
                .map((element: any) => element.expertCode)
            : [],
          assignementDetails: {
            contractorFees: assignement
              .filter((el: any) => !el.isForDelete && !el.id)
              .map((element: any) => ({
                uniqueId: uniqueId(),
                contractorTypeCode: returnDefaultCodeByType(
                  Number(get(assignExpert, 'type')),
                ),
                contractorCode: element.expertCode,
                amount: 0,
                isPayment: false,
              })),
            uuid: uuidV4(),
          },

          claimId: props.claimId,
          id: props.missionToUpdate.id,
          claimNumber: props.claimNumber,
          reference: props.missionToUpdate.reference,
          username: currentUserStorage.get().username,
          updatedBy: currentUserStorage.get().username,
          generateAssignementLetter: generateLetter,
          riskKey: props.riskKey,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        },
        successCallBackUpdate,
      );
    } else {
      props.requestAssignedExpert(
        {
          ...assignExpert,
          victims: [props.victimId],
          missionDate:
            get(assignExpert, 'missionDate') === '' ||
            get(assignExpert, 'missionDate') === 'Invalid date'
              ? null
              : get(assignExpert, 'missionDate'),

          claimId: props.claimId,
          generateAssignementLetter: generateLetter,
          //@ts-ignore
          intervenantSagis: get(assignExpert, 'assignedExperts', []).map(
            (element: any) => ({
              intervenantTypeCode: returnDefaultCodeByType(
                Number(get(assignExpert, 'type')),
              ),
              intervenantCode: element.expertCode,
            }),
          ),
          secondExamination:
            secondExaminationType === SECOND_EXAMINATION_VICTIM
              ? {
                  victimId: props.victimId,
                }
              : {
                  opposingLawyer: {
                    ...opposingLawyerInfo,
                  },
                },
          assignementDetails: {
            //@ts-ignore
            contractorFees: get(assignExpert, 'assignedExperts', []).map(
              (element: any) => ({
                uniqueId: uniqueId(),
                contractorTypeCode: returnDefaultCodeByType(
                  Number(get(assignExpert, 'type')),
                ),
                contractorCode: element.expertCode,
                amount: 0,
                isPayment: false,
              }),
            ),
            uuid: uuidV4(),
          },
          reserve: returnReserveCodeByType(
            Number(get(assignExpert, 'type')),
            props.listings,
          ),
          isTransactionMission: true,
          claimNumber: props.claimNumber,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          transactionId: props.transactionId,
          riskKey: props.riskKey,
          isTransactionInboxesActive: featureService.hasFeature(
            FEATURES.INBOXES_TRANSACTION_MANAGER,
          ),
          createdBy: currentUserStorage?.get().username,
        },
        successCallBack,
      );
    }
    props.handleToggleDrawer();
  };
  const successCallBack = () => {
    toast.success(translate(messages.successTitleAssign, props));
    props.requestGetMissionTransaction({ transactionId: props.transactionId });
  };
  const successCallBackUpdate = () => {
    toast.success(translate(messages.titleUpdateSuccess, props));
  };
  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate({ ...messages.ExpertDrawerTitle }, props, {
        number: null,
      })}
      handleClickPrimaryButton={handleOpenDialog}
      primaryButtonTitle={translate(messages.AssignButton, props)}
      isPrimaryButtonDisabled={
        isNil(get(assignExpert, 'type', null)) ||
        isEmpty(get(assignExpert, 'assignedExperts', null)) ||
        get(assignExpert, 'missionDate') === '' ||
        get(assignExpert, 'missionDate') === 'Invalid date' ||
        isEmpty(secondExaminationType) ||
        (secondExaminationType === SECOND_EXAMINATION_OPPOSING_LAWYER &&
          (isNilOrEmptyValue(
            get(opposingLawyerInfo, [OPPOSING_LAWYER_FIELDS.NAME], null),
          ) ||
            isNilOrEmptyValue(
              get(opposingLawyerInfo, [OPPOSING_LAWYER_FIELDS.ADRESS], null),
            ) ||
            isNilOrEmptyValue(
              get(opposingLawyerInfo, [OPPOSING_LAWYER_FIELDS.CITY], null),
            )))
      }
    >
      <ContainerInDrawer>
        <MissionForm
          assignExpert={assignExpert}
          setAssignExpertFields={setAssignExpert}
          listings={props.listings}
          corporealExperts={props.corporealExperts}
          requestGetExpertUsers={props.requestGetExpertUsers}
          setGenerateLetter={setGenerateLetter}
          generateLetter={generateLetter}
          setOpposingLawyerInfo={setOpposingLawyerInfo}
          opposingLawyerInfo={opposingLawyerInfo}
          setSecondExaminationType={setSecondExaminationType}
          secondExaminationType={secondExaminationType}
        />
      </ContainerInDrawer>
      <SahamDialog
        handleValidate={handleValidation}
        handleClose={handleCloseDialog as MouseEventHandler}
        title={translate(messages.courtManagerConfirmationDialogTitle, props)}
        cancelTitle={translate(
          messages.courtManagerConfirmationDialogCancel,
          props,
        )}
        confirmTitle={translate(
          messages.courtManagerConfirmationDialogConfirm,
          props,
        )}
        open={isDialogOpen}
      >
        {translate(messages.courtManagerConfirmationDialogContent, props)}
      </SahamDialog>
    </SahamDrawer>
  );
};

export default injectIntl(MissionDrawer);
